//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PackageLedgerEntryType } from './Enums';

export class PackageMinutesSearchOptions extends ItemBase {
    SearchText: string | null = null;
    IDs: string[] = [];
    PackageDefinitionIDs: string[] = [];
    TeacherIDs: string[] = [];
    StudentIDs: string[] = [];
    EntryTypes: PackageLedgerEntryType[] = [];
    StartDate: string | null = null;
    EndDate: string | null = null;
    ZeroMinutes: boolean | null = null;

    constructor(initializer?: Partial<PackageMinutesSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PackageMinutesSearchOptions";
}
